import { render, staticRenderFns } from "./ProductAdditionalResources.vue?vue&type=template&id=008e59ee&"
import script from "./ProductAdditionalResources.vue?vue&type=script&lang=js&"
export * from "./ProductAdditionalResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports